export default [
  {
    path: "/descontos",
    name: "Descontos",
    component: () => import("../views/Descontos"),
    meta: { requiresAuth: true },
  },
];
